import { LastResultsResponse, PlayerStats } from "../interfaces/playerStats";
import { api } from "./api";

export const getPlayerStats = async (id: number) => {
  const { data } = await api.get<PlayerStats>(`/api/v1/players/${id}/stats`);
  return data;
};

export const getPlayerResults = async (id: number, page: number) => {
  const { data } = await api.get<LastResultsResponse>(`/api/v1/players/${id}/stats/results?page=${page}&page_size=10`);
  return data;
};

export const exportPlayerResults = async (id: number) => {
  const response = await api.get(`/api/v1/players/${id}/stats/results/export/`, {
    responseType: "blob",
  });

  const contentDisposition = response.headers["content-disposition"];

  let filename = "reporte_jugador.xlsx";

  // Extraer nombre del archivo si viene en content-disposition
  const match = contentDisposition?.match(/filename="?(.+?)"?$/);
  if (match?.[1]) {
    filename = decodeURIComponent(match[1]);
  }

  const url = window.URL.createObjectURL(new Blob([response.data]));

  return { filename, url }
}